import {setServicePermission} from "./cookiePermissions";

export function initInScope($scope) {
    $scope.find('.js-allow-cookie-btn').on('click', function () {
        setServicePermission($(this).data('allow-cookie-btn-service-name'), true);
    });
}